import type { InterviewInsights } from "@repo/app-types/entities/interview";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";
import { SentimentScore } from "../../insights/sentimentScore.js";
import { ShareFragmentIconButton } from "./shareFragmentIconButton.js";

interface SentimentSectionProps {
  insights: InterviewInsights;
  onClickText: (text: string) => void;
  onClickShare: (text: string) => void;
}

export const SentimentSection: FC<SentimentSectionProps> = ({
  insights,
  onClickText,
  onClickShare,
}) => {
  const textClassName =
    "relative group py-1 px-2 pr-7 mb-2 rounded-sm inline-block text-sm";

  const renderShareButton = (quote: string) => {
    return (
      <div className="absolute top-1/2 right-1 -translate-y-1/2 transform space-x-2">
        <ShareFragmentIconButton
          onClick={() => {
            onClickShare(quote);
          }}
        />
      </div>
    );
  };

  return (
    <>
      <div className="text-sm text-foreground">
        {insights.sentiment_score ? (
          <div className="mb-2">
            <SentimentScore score={insights.sentiment_score} />
          </div>
        ) : null}
        {(insights.key_positive_quotes || []).map((quote, i) => {
          return (
            <div
              className={twMerge(
                textClassName,
                "cursor-pointer bg-green-50 text-green-950 hover:bg-green-100",
              )}
              onClick={() => onClickText(quote)}
              key={`positive-quote-${i}`}
            >
              {quote}
              {renderShareButton(quote)}
            </div>
          );
        })}
        {(insights.key_negative_quotes || []).map((quote, i) => {
          return (
            <div
              className={twMerge(
                textClassName,
                "cursor-pointer bg-red-50 text-red-950 hover:bg-red-100",
              )}
              onClick={() => onClickText(quote)}
              key={`negative-quote-${i}`}
            >
              {quote}
              {renderShareButton(quote)}
            </div>
          );
        })}
      </div>
    </>
  );
};
